import useResizeLayout from '@Hooks/useResizeLayout';
import { useGetProfileLegalInfoQuery } from '@Store/api/dictionaryApiSlice';
import { Details } from './components/Details';

const LegalInfo: React.FC = () => {
  const { isMobile } = useResizeLayout();
  const { data } = useGetProfileLegalInfoQuery();

  if (!data) {
    return null;
  }

  return <Details legalInfoData={data} isMobile={isMobile} />;
};

export default LegalInfo;
